import { c as getDateTimeFormat } from './formatDate-3c9d186b-20057f2b.js';

const getTimeOptions = ({
  timezone
}) => ({
  hour: 'numeric',
  hour12: true,
  minute: 'numeric',
  timeZoneName: 'short',
  timeZone: timezone
});

/**
 * @param {Date} date The date to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {string} timezone The time zone to use (e.g. America/New_York).
 * The default is the runtime's default time zone.
 */
const formatTime = getDateTimeFormat(getTimeOptions);
var formatTime$1 = formatTime;

export { formatTime$1 as f, getTimeOptions as g };
//# sourceMappingURL=formatTime-92165ff9-e60c18fa.js.map
